import { createReducer } from 'typesafe-actions';
import { OPEN_FROM_BANNER, SWITCH_MODAL } from './actions';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
export type Action = ActionType<typeof actions>;

export const initialState = {
  open: false,
  fromBanner: false
};

export const modal = createReducer<typeof initialState, Action>(initialState, {
  [SWITCH_MODAL]: (state, action) => {
    return {
      open: action.payload,
      fromBanner: false
    };
  },
  [OPEN_FROM_BANNER]: () => {
    return {
      open: true,
      fromBanner: true
    };
  }
});
